import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { context } from '../../../globalState/GlobalState';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import './css/Articles1.css';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import SocialsComponent2 from '../../uiElements/socialsComponents/socialsComponent2/SocialsComponent2';
import ArticleThumbnail4 from '../../uiElements/articleThumbnails/articleThumbnail4/ArticleThumbnail4';
import Title4 from '../../uiElements/title/title4/Title4';
import PlaceholderComponent2 from '../../uiElements/placeholderComponents/placeholderComponent2/PlaceholderComponent2';

const Articles1 = (props) => {
    const { articles, loadingSpinner } = props;
    const { globalState } = useContext(context);

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
        ];
    };

    return (
        <>
            <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb="Articles" marginLeft="100px" />
            <div className="articles1-container-container x-center p-t-20px p-b-20px p-l-50px p-r-50px m-b-20px">
                <Title4 title="News" />
                <div className="articles1-container m-t-0">
                    <div className="articles1-articles-container">
                        <h2 className="font-size-3xl m-t-0 m-b-20px text-uppercase">Articles</h2>
                        {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                            <>
                                {articles.length > 0 ? (
                                    <div className="articles1-articles">
                                        {articles.map((article) => {
                                            return (
                                                <div key={article.id} className="articles1-article m-l-0 m-r-20px m-b-20px">
                                                    <ArticleThumbnail4 article={article} />
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : <PlaceholderComponent2 text="No Articles Available" />}
                            </>
                        )}
                    </div>
                    <div className="articles1-socials">
                        <h2 className="font-size-3xl m-t-0 m-b-20px text-uppercase">Social</h2>
                        <SocialsComponent2 />
                    </div>
                </div>
            </div>
        </>
    );
};

Articles1.propTypes = {
    articles: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(Articles1);
